import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { logout } from "../login/loginSlice"
import { User, UserState } from "./userTypes"

const initialState: UserState = {
    user: undefined
}

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUser: (_state, action: PayloadAction<User>) => {
            return { user: action.payload }
        }
    },
    extraReducers(builder) {
        builder.addCase(logout, (_state, _action) => {
            return initialState
        })
    },
})

export const { setUser } = userSlice.actions
export const userReducer = userSlice.reducer
